import { jsx as _jsx } from "react/jsx-runtime";
const LogoImageAvailability = ({ src = '' }) => {
    if (!src)
        return null;
    return _jsx("img", { src: src, alt: "", className: "logo_img_availability" });
};
export default LogoImageAvailability;
